import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="logo">
            <img
              src="https://ucarecdn.com/c1c1dab1-1119-49ef-b9b2-a918dd005127/-/format/auto/"
              alt="University of Languages Logo"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </div>
          <p>
            Unlocking Global Communication through expert language education
            and professional services.
          </p>
        </div>
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/courses">Courses</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/features">Features</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Languages</h4>
          <ul>
            <li><Link to="/courses#german">German</Link></li>
            <li><Link to="/courses#spanish">Spanish</Link></li>
            <li><Link to="/courses#japanese">Japanese</Link></li>
            <li><Link to="/courses#korean">Korean</Link></li>
            <li><Link to="/courses#french">French</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Contact Info</h4>
          <div>
            <p>Email: info@universityoflanguages.com</p>
            <p>Phone: +91 82172 34825</p>
            <p>WhatsApp: +91 82172 34825</p>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 University of Languages. All rights reserved.</p>
      </div>
    </footer>
  );
}
